import config from '../config';
import selectedEnvironment from '../env';

const API_URL = `${config[selectedEnvironment].API_URL}`;

const CreateGroup = async (dto, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/Create`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(dto)
    });
    return response;
};

const UpdateGroup = async (dto, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/Update`, {
        method: 'PUT',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(dto)
    });
    return response;
};

const DeleteGroup = async (groupId, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/${groupId}`, {
        method: 'DELETE',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });
    return response;
};

const GetGroupById = async (groupId, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/${groupId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });
    return response;
};

const GetGroupByItemId = async (docType, itemId, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/by-item/${docType}/${itemId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });
    return response;
};

const GetGroupByItemIdOnly = async (itemId, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/by-item-id/${itemId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });
    return response;
};

const GetGroupItems = async (groupId, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/${groupId}/items`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });
    return response;
};

const AddItemToGroup = async (groupId, dto, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/${groupId}/add-item`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(dto)
    });
    return response;
};

const RemoveItemFromGroup = async (groupId, itemId, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/${groupId}/remove-item/${itemId}`, {
        method: 'DELETE',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });
    return response;
};

const GetGroupsByCaseId = async (caseId, token) => {
    const response = await fetch(`${API_URL}/JournalGroups/by-case/${caseId}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        }
    });
    return response;
};

const JournalGroupService = {
    CreateGroup,
    UpdateGroup,
    DeleteGroup,
    GetGroupById,
    GetGroupByItemId,
    GetGroupByItemIdOnly,
    GetGroupItems,
    AddItemToGroup,
    RemoveItemFromGroup,
    GetGroupsByCaseId
};

export default JournalGroupService;
